import {FC, useState, createContext, useContext} from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../_metronic/helpers'

const DLMTypesQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMTypesQueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<QueryState>(initialQueryRequest.state)

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  return (
    <DLMTypesQueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </DLMTypesQueryRequestContext.Provider>
  )
}

const useDLMTypesQueryRequest = () => useContext(DLMTypesQueryRequestContext)
export {DLMTypesQueryRequestProvider, useDLMTypesQueryRequest}
